export const CartCommon = {
  CartCommon: {
    label: {
      name: 'Nom',
      number: 'Numéro',
      status: 'Statut',
      requestedDeliveryDate: 'Date de livraison demandée',
      customerPO: 'Bon de commande du client',
      jobNameNumber: 'Nom / Numéro du travail',
      shipComplete: 'Expédier en totalité',
      headerNotes: 'Instruction spéciale',
      referenceCart: 'Brouillon de commande de référence',
      createdBy: 'Créé par',
      createdDate: 'Date de création',
      lastUpdatedDate: 'Date de dernière mise à jour',
      submitForApproval: 'Soumettre pour approbation',
      checkout: 'Passer la commande',
      totalItems: "Nombre total d'articles :",
      totalQuantity: 'Quantité totale :',
      totalPrice: 'Prix total :',
      itemDetails: "Détails de l'article",
      productDetails: 'Détails du produit',
      plant: 'Usine',
      requestedShipDate: "Date d'expédition demandée",
      listPrice: 'Prix de liste',
      netPrice: 'Prix net',
      quantity: 'Quantité',
      total: 'Total',
      priceAdjustment: 'Ajustement de prix',
      quoteReference: 'Référence de la soumission',
      uom: 'Unité de mesure',
      moq: 'QMC (Quantité minimale de commande)',
      actions: 'Actions',
      cart: 'Panier',
      downloadPDF: 'Télécharger le PDF',
      createdOn: 'Créé le',
      saveUpdatedCart: 'Sauvegarder le panier mis à jour',
      lineNo: 'N° de ligne',
      update: 'Mettre à jour le panier',
      atgDivision: 'Division ATG',
      customerName: 'Nom du compte',
      customerAccount: 'Compte client',
      specialInstructions: 'Instructions spéciales',
      productAvailability: "Disponibilité du produit / Délai de traitement",
      customerMaterialNumber: 'Numéro de matériel du client',
      promoCode: 'Code promotionnel',
      salesDeal: 'Offre commerciale',
      quote: 'Numéro de soumission',
      costCentre: 'Centre de coûts',
      storeNumber: 'Numéro de magasin',
      deliveryUnitAdjusted: 'La quantité de la commande doit être un multiple de l\'unité de livraison {{ unit }}',
      moqAdjusted: 'La quantité de la commande doit être supérieure ou égale à la quantité minimale de commande.',
    },
    reorderConfirmDialog: {
      title: 'Brouillon de commande actif',
      body: 'Vous avez actuellement un brouillon de commande actif. Vous êtes sur le point de recommander des articles d\'une commande historique. Comment souhaitez-vous procéder ?',
      continueWithActive: 'Continuer avec le brouillon de commande actif',
      createNew: 'Créer un nouveau brouillon de commande',
    },
    createMessage: {
      success: 'Le brouillon de commande a été créé avec succès.',
      error: 'Une erreur est survenue lors de la création du brouillon de commande.',
    },
    copyMessage: {
      success: 'Le brouillon de commande a été copié avec succès.',
      error: 'Une erreur est survenue lors de la copie du brouillon de commande.',
    },
    updateMessage: {
      success: 'Le brouillon de commande a été mis à jour avec succès.',
      error: 'Une erreur est survenue lors de la mise à jour du brouillon de commande.',
    },
    deleteMessage: {
      success: 'Le brouillon de commande a été supprimé avec succès.',
      error: 'Une erreur est survenue lors de la suppression du brouillon de commande.',
    },
    invalidQtyMessage: {
      entryMessage: 'Veuillez saisir une quantité valide (multiple de la QMC) pour cet article',
      globalMessage: 'Veuillez saisir une quantité valide (multiple de la QMC) pour les numéros de ligne {{ linenos }}',
    },
    commentMessage: {
      isGenericGlobalMessage:
        "Pour le(s) produit(s) : {{ linenos }}, veuillez remplir le champ obligatoire (feuille de travail d'arc, n° de plan ou commentaires)",
      isSinkPatternGlobalMessage:
        'Pour le(s) produit(s) : {{ linenos }}, vous devez choisir la configuration de perçage requise dans le menu déroulant.',
    },
    referenceRemovedMessage: 'La référence de la soumission a été mise à jour avec succès.',
    validation: {
      duplicatePONumber: 'Numéro de B.C. en double détecté',
      purchaseOrderNumber: {
        maxlength: 'Le B.C. client ne peut pas dépasser 25 caractères',
        pattern: 'Le B.C. client ne peut pas contenir de caractères spéciaux',
      },
    },
    messages: {
      discontinuedCannotOrder: 'Cet article {{ code }} est discontinué et ne peut pas être commandé.',
      partialReorderSkippedItems: 'Un ou plusieurs articles de cette commande historique ne sont plus disponibles dans le catalogue et ont été ignorés. Veuillez vérifier votre panier pour confirmer les lignes chargées.',
    },
    toolTip: {
      promoCode: 'Le prix promotionnel sera reflété sur votre confirmation de commande une fois la commande traitée.',
      quote: 'Le prix de soumission (SPR) n’est pas affiché dans ATG Connect. Tout prix de soumission approuvée sera indiqué sur votre confirmation de commande.',
    },
  },
};
export const cartSearchForm = {
  label: {
    draftOrderName: 'Nom',
    accountNumber: 'Numéro de compte',
    accountName: 'Nom du compte',
    customerPO: 'Bon de commande du client',
    jobNameNumber: 'Nom / Numéro du travail',
    status: 'Statut',
    draftOrderNumber: 'Numéro',
  },
};
export const cartResult = {
  header: {
    draftOrderNumber: 'Numéro',
    draftOrderName: 'Nom',
    createdBy: 'Créé par',
    creationDate: 'Date de création',
    createdOn: 'Créé le',
    accountNo: 'N° de compte',
    accountName: 'Nom du compte',
    customerPO: 'Bon de commande du client',
    jobNameNumber: 'Nom / Numéro du travail',
    status: 'Statut',
    total: 'Total',
    actions: 'Actions',
    job: 'Travail',
    updateBy: 'Mis à jour par',
  },
  nodataMsg: 'Les brouillons de commande apparaîtront ici une fois qu\'ils auront été créés et enregistrés.',
  showMore: 'Afficher plus',
};
export const addToCartMessage = {
  success: 'Les produits ont été ajoutés au brouillon de commande avec succès.',
  failure: "Échec de l'ajout des produits au brouillon de commande.",
};
